import React, { useContext } from "react";
import { SolidCloseIcon } from "~/assets/svg/CloseIcon";
import { SearchIcon } from "~/assets/svg/InterfaceIcon";
import useAlert from "~/common/hooks/useAlert";
import { AppManContext } from "../../../RoundManContext";
import { Trans, useTranslation } from "react-i18next";

const ProOneSetting = () => {
	const { t } = useTranslation();
	const { roundData, addProSteps, setAddProSteps, resultFromProOne, setresultFromProOne } =
		useContext(AppManContext);

	const [showCompanySelectAlert, CompanySelectAlert] = useAlert();

	const applyCompany = roundData?.applyCompany || [];
	const roundJudge = roundData?.round.Judge || [];
	const selectedCompList =
		applyCompany.filter((d) => resultFromProOne.find((c) => c === d.stIdx)) || [];

	const moveToNextStep = () => {
		if (resultFromProOne.length === 0) {
			showCompanySelectAlert();
			return;
		}
		setAddProSteps(addProSteps + 1);
	};

	const selectCompany = (idx) => {
		const duplicated = resultFromProOne.find((r) => r === idx);
		if (duplicated) {
			const newData = resultFromProOne.filter((r) => r !== idx);
			setresultFromProOne(newData);
			return;
		}
		setresultFromProOne([...resultFromProOne, idx]);
	};

	const selectAll = () => {
		if (resultFromProOne.length > 0) {
			setresultFromProOne([]);
			return;
		}
		setresultFromProOne(applyCompany.map((d) => d.stIdx));
	};

	return (
		<>
			<div className="modal-content addCompany">
				<div className="participant-list">
					<div className="setup-card-top">
						<h4 className="sub-title">
							<Trans
								i18nKey="pages.round.RoundManage.modal.additionalRound.steps.ProOneSetting.title"
								components={[<b />]}
							/>
						</h4>
						<div className="c__search circle">
							<input
								className="c__input"
								placeholder={t(
									"pages.round.RoundManage.modal.additionalRound.steps.ProOneSetting.inputPlaceholder"
								)}
							/>
							<button type="button" className="btn-search">
								<SearchIcon />
							</button>
						</div>
					</div>
					<div className="c__card">
						<div className="c__table">
							<div className="thead">
								<div className="tr">
									<div className="th company-chk">
										<label className={`checkbox-custom`}>
											<input
												type="checkbox"
												checked={
													selectedCompList.length === applyCompany.length
												}
												onChange={selectAll}
											/>
											<span className="checkmark" />
										</label>
									</div>
									<div className="th company-rank">
										{t(
											"pages.round.RoundManage.modal.additionalRound.steps.ProOneSetting.setupTable.tableHead01"
										)}
									</div>
									<div className="th company-name">
										{t(
											"pages.round.RoundManage.modal.additionalRound.steps.ProOneSetting.setupTable.tableHead02"
										)}
									</div>
									<div className="th company-type">
										{t(
											"pages.round.RoundManage.modal.additionalRound.steps.ProOneSetting.setupTable.tableHead03"
										)}
									</div>
									<div className="th company-score">
										{t(
											"pages.round.RoundManage.modal.additionalRound.steps.ProOneSetting.setupTable.tableHead04"
										)}
									</div>
								</div>
							</div>
							<div className="tbody">
								{applyCompany.map((d, idx) => {
									let sum = 0;
									roundJudge.forEach((da) => {
										const temp = da.Company.find((c) => c.stIdx === d.stIdx);
										sum += temp?.score || 0;
									});

									return (
										<div className="tr" key={d.idx}>
											<div className="td company-chk">
												<label className={`checkbox-custom`}>
													<input
														type="checkbox"
														checked={resultFromProOne.find(
															(r) => r === d.stIdx
														)}
														onChange={() => selectCompany(d.stIdx)}
													/>
													<span className="checkmark" />
												</label>
											</div>
											<div className="td company-rank">{idx + 1}</div>
											<div className="td company-name">{d.companyName}</div>
											<div className="td company-type">{d.business}</div>
											<div className="td company-score">{sum.toFixed(2)}</div>
										</div>
									);
								})}
							</div>
						</div>
					</div>
				</div>
				<div className="selected-list">
					<h4 className="sub-title">
						{t(
							"pages.round.RoundManage.modal.additionalRound.steps.ProOneSetting.selectedTitle"
						)}
						({selectedCompList.length})
					</h4>
					<div className="c__card">
						<div className="c__table">
							<div className="thead">
								<div className="tr">
									<div className="th company-rank">
										{t(
											"pages.round.RoundManage.modal.additionalRound.steps.ProOneSetting.selectedTable.tableHead01"
										)}
									</div>
									<div className="th company-name">
										{t(
											"pages.round.RoundManage.modal.additionalRound.steps.ProOneSetting.selectedTable.tableHead02"
										)}
									</div>
								</div>
							</div>
							<div className="tbody">
								{selectedCompList.map((d, idx) => {
									return (
										<div className="tr" key={idx}>
											<div className="td company-rank">{idx + 1}</div>
											<div className="td company-name">{d.companyName}</div>
											<button
												type="button"
												className="td btn-close"
												onClick={() => selectCompany(d.stIdx)}
											>
												<SolidCloseIcon />
											</button>
										</div>
									);
								})}
							</div>
						</div>
						{/*//---- Empty*/}
						{/*<div className="c__noData">*/}
						{/*	<CautionIcon />*/}
						{/*	<p className="main">심사기업을 선택해 주세요.</p>*/}
						{/*</div>*/}
					</div>
					<button
						type="button"
						className="btn__solid angled"
						color="primary"
						onClick={moveToNextStep}
					>
						{t(
							"pages.round.RoundManage.modal.additionalRound.steps.ProOneSetting.next"
						)}
					</button>
				</div>
			</div>

			<CompanySelectAlert
				type="warning"
				message={t(
					"pages.round.RoundManage.modal.additionalRound.steps.ProOneSetting.warningText"
				)}
				confirm={t(
					"pages.round.RoundManage.modal.additionalRound.steps.ProOneSetting.confirm"
				)}
			/>
		</>
	);
};

export default ProOneSetting;
